import BuildTypes from 'src/constants/BuildTypeConstants';
import Styles from 'src/components/Styles';
import Settings from 'src/Settings';

const offersThemeConfiguration = {
  [BuildTypes.canteen]: {
    buttonColor: Styles.Colors.Canteen.darkGreen,
    textFontFamily: Styles.FontFamily.robotoRegular,
    textColor: Styles.Colors.PayNew.black01,
  },
  [BuildTypes.default]: {
    buttonColor: Styles.Colors.PayNew.primary01,
    textFontFamily: Styles.FontFamily.aeonikRegular,
    textColor: Styles.Colors.PayNew.black01,
  },
  [BuildTypes.refive]: {
    buttonColor: Styles.Colors.PayNew.primary01,
    textFontFamily: Styles.FontFamily.figtreeRegular,
    textColor: Styles.Colors.PayNew.black01,
  },
  [BuildTypes.companykitchen]: {
    buttonColor: Styles.Colors.CompanyKitchen.green,
    textFontFamily: Styles.FontFamily.latoRegular,
    textColor: Styles.Colors.PayNew.black01,
  },
};

export const offersTheme = offersThemeConfiguration[Settings.buildType];
